import { CardTitle } from "reactstrap";
import __ from "src/utils/Translations";

const displayList = (data, title) => (
  <div>
    <CardTitle>{__(title)}</CardTitle>
    <ul style={{ listStyle: "none" }}>
      {Object.entries(data).map(([key, value]) => (
        <li>
          <code>
            {key}: {value || "-"}
          </code>
        </li>
      ))}
    </ul>
  </div>
);

export default displayList;
